import React from 'react';
import { Box, SvgIcon, Typography } from '@mui/material';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';

interface OwnProps {
    title: string;
    subtitle: string;
    hideIcon?: boolean;
}

const OnboardingHeader: React.FC<OwnProps> = ({ title, subtitle, hideIcon = false }) => {
  const { isXsScreen } = useScreenSize();

  return (
    <Box data-testid='onboarding-page-form-header'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: isXsScreen ? spaces.md : spaces.lg
      }}>
      {!hideIcon && (
        <SvgIcon
          data-testid='onboarding-page-form-header-icon'
          component={getMuiIcon('muLogoBagOnboarding')}
          viewBox='0 0 64 64'
          sx={{
            height: '64px !important',
            width: '64px !important',
          }}
        />
      )}
      <Typography
        variant={isXsScreen ? 'h6' : 'h4'}
        sx={{ 
          color: palette.text.primary,
          fontWeight: 600,
          textAlign: 'center',
          whiteSpace: 'pre-line'  // So that the title breaks on new lines
        }}>
        {title}
      </Typography>
      <Typography
        variant={isXsScreen ? 'body2' : 'body1'}
        sx={{ 
          color: palette.text.secondary,
          textAlign: 'center',
        }}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default OnboardingHeader;
